module.exports = __webpack_public_path__ + "img/icon_paging_nextt.7eb9d4d7.svg";